export function getQueryStringValue(name, url = window.location.href) {
    name = name.replace(/[[]]/g, "\\$&");

    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
    const results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getHashValue(url = window.location.href) {
    let s = url;

    if (s.indexOf("#") < 0) return "";
    s = s.substr(s.indexOf("#") + 1);
    s = s.replace("?", "&");
    var ipos = s.indexOf("&");
    if (ipos >= 0) s = s.substr(0, ipos);
    return s;
}

export function generateBackUrl(history) {
    let backUrl = history.location.pathname
        + history.location.hash
        + history.location.search;
    return btoa(backUrl);
}

export function getBackUrlEncoded(key = "from") {
    let backUrl = getQueryStringValue(key);
    if (backUrl !== undefined && backUrl !== null && backUrl.length > 0) {
        return backUrl;
    }
    return undefined;
}

export function getBackUrlDecoded(key = "from") {
    let backUrl = getBackUrlEncoded(key);
    if (backUrl !== undefined && backUrl !== null && backUrl.length > 0) {
        try {
            return atob(backUrl);
        }
        catch (e) {
        }
    }
    return undefined;
}

export function getFullUrl(history){
    return history.location.pathname + history.location.hash + history.location.search;
}


const QueryStringUtils = {
    getQueryStringValue,
    getHashValue,
    generateBackUrl,
    getBackUrlEncoded,
    getBackUrlDecoded,
    getFullUrl
};
export default QueryStringUtils;
